export default __webpack_public_path__ + "static/media/znak.ef1351ac.svg";